import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Text,
  // Icon,
  Input,
  useToast,
  Link,
  VStack,
  IconButton,
  Button,
} from "@chakra-ui/react";
import { FiUploadCloud } from "react-icons/fi";
import { Icon } from "@iconify/react/dist/iconify.js";
import { convertPdfToImage, getMinioImage } from "../../../../../utils/helpers";
import ImgOptimized from "../../../../../components/ImgOptimized";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import PopupWrapper from "../../../../../components/PopupWrapper";

const UploadFileStyleTwo = ({
  label,
  setFile,
  file,
  required = false,
  multiple = false,
  isManualDelete = false,
  isViewOnly = false,
  isEnableCropping = false,
  cropData = [],
  setCropData = (cropdata) => {},
}) => {
  console.log({ cropData });
  const [dragOver, setDragOver] = useState(false);
  const [isCrop, setIsCrop] = useState(false);
  const [crop, setCrop] = useState({
    unit: "%",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
  });
  const [cropIdx, setCropIdx] = useState(null);
  const inputRef = useRef(null);
  const toast = useToast();

  // console.log(file, "file in UploadFileStyleTwo");
  // const viewFile = Array.isArray(file) ? file: file?  [file]: [];

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    if (e.dataTransfer.files.length) {
      setFile(e.dataTransfer.files, null);
    }
  };

  const handleAddImages = () => {};
  if (!Array.isArray(file)) {
    file = [file];
  }
  file = file?.[0] == "" ? [] : file;
  console.log("FILES", { label, file, curr: getMinioImage(file?.[0]) });
  return (
    <Box w={"full"} display={"flex"} flexDir={"column"} h={"full"}>
      <div className="flex items-center justify-between  w-full ">
        <Text mb={2} fontSize={"sm"} fontWeight="medium">
          {label}
          {required && <span className="text-red-500"> *</span>}
        </Text>
        {multiple && (
          <Button
            colorScheme="teal"
            size={"sm"}
            onClick={() => inputRef && inputRef?.current?.click()}
          >
            Add Images
          </Button>
        )}
      </div>

      <Box
        border="2px dashed"
        borderColor={dragOver ? "blue.400" : "gray.300"}
        borderRadius="md"
        flexGrow={1}
        p={4}
        mt={2}
        textAlign="center"
        w={"full"}
        h={"full"}
        bg={dragOver ? "gray.50" : "white"}
      >
        {file?.length > 0 ? (
          <div className=" flex items-center justify-center gap-4 flex-wrap max-h-60 overflow-y-auto pt-4">
            {/* {viewFile.map((file, index) =>} */}
            {file.map((curr, idx) => (
              <div className="relative">
                <ImgOptimized
                  src={
                    curr instanceof Blob
                      ? URL.createObjectURL(curr)
                      : getMinioImage(curr)
                  }
                  alt={label}
                  className="w-24 h-24 object-cover rounded-lg"
                />
                {/* {getMinioImage( curr) } */}
                {!isViewOnly && (
                  <div className="absolute -top-3 -right-3 ">
                    <div
                      onClick={() =>
                        isManualDelete
                          ? setFile(file, idx)
                          : setFile(
                              file.filter((_, i) => idx != i),
                              true,
                              idx,
                            )
                      }
                      className="text-2xl p-0.5 cursor-pointer "
                    >
                      <Icon
                        icon={"line-md:trash"}
                        className="text-red-500 hover:text-red-700 cursor-pointer text-2xl"
                      />
                    </div>
                  </div>
                )}
                {isEnableCropping && (
                  <div className="absolute -top-3 -left-2 ">
                    <div
                      onClick={() => {
                        setIsCrop(curr);
                        setCropIdx(idx);
                        setCrop(
                          cropData?.[idx] || {
                            unit: "%",
                            x: 0,
                            y: 0,
                            width: 80,
                            height: 80,
                          },
                        );
                      }}
                      className="text-2xl p-0.5 cursor-pointer "
                    >
                      <Icon
                        icon={"tabler:edit"}
                        className="text-yellow-500 hover:text-yellow-700 cursor-pointer text-2xl"
                      />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <>
            {!isViewOnly ? (
              <Box
                onDragOver={(e) => {
                  e.preventDefault();
                  setDragOver(true);
                }}
                onDragLeave={() => setDragOver(false)}
                onDrop={handleDrop}
                cursor="pointer"
                onClick={() => inputRef.current.click()}
              >
                {" "}
                <VStack spacing={2}>
                  <Icon
                    icon={"iconoir:cloud-upload"}
                    width={"40px"}
                    color="gray"
                  />
                  <Text>
                    Drag and drop file here or{" "}
                    <Link color="blue.500">Choose file</Link>
                  </Text>
                  {/* <Text fontSize="sm" color="gray.500">
                Only PNG/JPEG/PDF Allowed
              </Text> */}
                </VStack>
              </Box>
            ) : (
              <div className="flex items-center justify-center    h-full">
                <Icon icon="mdi:map" className="text-3xl text-teal-500" />
                <span className="ml-3 text-teal-600 font-semibold text-lg">
                  Empty Floormap
                </span>
              </div>
            )}
          </>
        )}
        <Text fontSize="sm" color="gray.500" mt={4}>
          Only PNG/JPEG/PDF Allowed
        </Text>
        <Input
          type="file"
          accept="image/png, image/jpeg, application/pdf"
          multiple={multiple}
          hidden
          ref={inputRef}
          onChange={async (e) => {
            const pdfToImg = await Promise.all(
              [...e.target.files].map((img) => {
                if (img.type !== "application/pdf") return img;
                return convertPdfToImage(img);
              }),
            );
            console.log(
              "FLOORPLAN",
              file,
              e.target.files,
              [...e.target.files],
              pdfToImg,
            );
            multiple
              ? setFile([...file, ...pdfToImg], null)
              : setFile([...pdfToImg], null);
          }}
        />
      </Box>

      {isCrop && (
        <CropPopupModal
          onClose={() => {
            setIsCrop(false);
            setCropIdx(null);
          }}
          image={isCrop}
          crop={crop}
          setCrop={setCrop}
          onSave={(croppedData) => {
            console.log("Cropped Info:", croppedData);
            let updatedCropData = [...cropData];
            updatedCropData[cropIdx] = croppedData?.cropConfig;
            setCropData(updatedCropData);
            //
            // setCropData([...cropData, croppedData]);
            setIsCrop(false);
            setCropIdx(null);
          }}
        />
      )}
    </Box>
  );
};

const CropPopupModal = ({ onClose, image, crop, setCrop, onSave }) => {
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (image instanceof Blob) {
      setImageUrl(URL.createObjectURL(image));
    } else {
      setImageUrl(getMinioImage(image));
    }

    return () => {
      if (image instanceof Blob && imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [image]);

  return (
    <PopupWrapper
      heading={"Crop Image"}
      isShowAction={true}
      isDisbledSubmit={crop.width == 0 || crop.height == 0}
      handleSubmit={() => {
        const croppedData = {
          image: image instanceof Blob ? URL.createObjectURL(image) : image,
          cropConfig: crop,
          timestamp: new Date().toISOString(),
        };
        console.log("Cropped Info Log:", croppedData);
        onSave(croppedData);
        onClose();
      }}
      onClose={onClose}
      width={"max-w-2xl"}
    >
      <div className="max-h-[70vh]  overflow-y-auto overflow-x-hidden w-full">
        {imageUrl && (
          <ReactCrop
            crop={crop}
            onChange={(c, percent) => {
              setCrop(percent);
            }}
          >
            <img src={imageUrl} alt="Crop" />
          </ReactCrop>
        )}
      </div>
    </PopupWrapper>
  );
};

export default UploadFileStyleTwo;
